
import { Vue, Component, Prop } from 'vue-property-decorator'
import Axios, { AxiosInstance } from 'axios'

enum Method
{
    GET = 'GET',
    HEAD = 'HEAD',
    POST = 'POST',
    PUT = 'PUT',
    PATCH = 'PATCH',
    DELETE = 'DELETE',
}

@Component
export default class AjaxForm extends Vue
{
    static dataMethods: Method[] = [
        Method.POST,
        Method.PUT,
        Method.PATCH,
    ]

    @Prop({
        default: () => Axios,
    }) axios!: AxiosInstance

    @Prop({
        type: String,
        default: '#',
    }) action!: string

    @Prop({
        type: String,
        default: Method.POST,
        validator: value => Object.values(Method).includes(value.toUpperCase()),
    }) method!: Method

    @Prop({
        type: Object,
        default: () => ({}),
    }) data!: { [key: string]: any, [key: number]: any }

    get isDataMethod(): boolean
    {
        return AjaxForm.dataMethods.indexOf(this.method) > -1
    }

    async submit()
    {
        const { axios, action, method, isDataMethod } = this

        const formData = new FormData(this.$el as HTMLFormElement)
        const data: { [key: string]: any } = {}

        for (const key in this.data) {
            if (this.data.hasOwnProperty(key)) {
                formData.set(key, this.data[key])
            }
        }

        if (!isDataMethod) {
            for (const [key, value] of formData.entries()) {
                data[key] = value
            }
        }

        this.$emit('before', { axios, action, method, data: isDataMethod ? formData : data })

        const dataConfig = isDataMethod ? { data: formData } : { params: data }

        try {
            const response = await axios.request({
                data,
                url: action,
                method: method.toLowerCase(),
                ...dataConfig,
            })

            this.$emit('success', response)
        } catch (error) {
            this.$emit('error', error.response)
        }

        this.$emit('complete')
    }
}
